import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IUnmatchedPushTotalBalanceResponse } from '@/dtos';

export const UNAPPLIED_FUNDS_BALANCE_QUERY_KEY = 'UNAPPLIED_FUNDS_BALANCE_QUERY';

const useUnappliedFundsBalanceQuery = (organizationId?: string) => {
  const { data, isLoading } = useQuery(
    [UNAPPLIED_FUNDS_BALANCE_QUERY_KEY, organizationId],
    () =>
      api.get<IUnmatchedPushTotalBalanceResponse>(API_URL.UNMATCHED_PUSH_TRANSACTIONS_TOTAL_BALANCE, {
        params: { organization_id: organizationId },
      }),
    { enabled: Boolean(organizationId) }
  );

  return {
    balance: data?.data?.total_balance ?? 0,
    isLoading,
  };
};

export default useUnappliedFundsBalanceQuery;
